import { PrezilinkerService } from '@prezi/prezilinker-client';
import { $switchCaseDefault } from 'dolla-switch';
export const getViewlinks = documentOid => PrezilinkerService.get({
  preziOid: documentOid,
  listAllPrezilinks: true,
  includeSharer: true
}).then(arr => arr.map(mapToViewLink));
export const createViewlink = (documentOid, name, visibleOnAnalytics, viewerIdentification) => PrezilinkerService.create({
  prezilink: {
    prezi_oid: documentOid,
    name,
    visible_on_analytics: visibleOnAnalytics,
    viewer_identification: viewerIdentification
  }
}).then(mapToViewLink);
export const updateViewlink = (linkId, name, visibleOnAnalytics, viewerIdentification) => PrezilinkerService.updateItem({
  linkId,
  prezilink: {
    name,
    visible_on_analytics: visibleOnAnalytics,
    viewer_identification: viewerIdentification
  }
}).then(mapToViewLink);
export const deleteViewlink = linkId => PrezilinkerService.deleteItem({
  linkId
});
export const revokeViewlink = (linkId, deleteData) => PrezilinkerService.updateItem({
  linkId,
  prezilink: {
    revoked: true,
    visible_on_analytics: !deleteData
  }
}).then(mapToViewLink);
export const getUnlistedShareLink = documentOid => PrezilinkerService.getUnlistedItem({
  preziOid: documentOid
}).then(mapToUnlistedShareLink).catch(error => {
  if (error.status === 404) {
    return Promise.resolve(null);
  } else {
    return Promise.reject(error);
  }
});
export const createOrRegenerateUnlistedShareLink = documentOid => PrezilinkerService.updateUnlistedItem({
  preziOid: documentOid
}).then(mapToUnlistedShareLink);
export const deleteUnlistedLink = documentOid => PrezilinkerService.deleteUnlistedItem({
  preziOid: documentOid
});
const mapToUnlistedShareLink = link => ({
  link_id: link.link_id,
  prezi_oid: link.prezi_oid,
  url: link.url
});
const mapToViewLink = link => ({
  link_id: link.link_id,
  prezi_oid: link.prezi_oid,
  owner_oid: link.owner_oid,
  name: link.name,
  created_at: link.created_at,
  revoked: link.revoked,
  visible_on_analytics: link.visible_on_analytics,
  viewer_identification: link.viewer_identification,
  onboarding: link.onboarding,
  permissions: link.permissions,
  sharer_first_name: link.sharer_first_name,
  sharer_last_name: link.sharer_last_name,
  is_unlisted_implicit: !!link.is_unlisted_implicit,
  is_owner: !!link.is_owner
});
export const getViewlinkUrl = (linkId, schemaVersionName, referralToken) => {
  const referralTokenQuery = referralToken ? `?referral_token=${referralToken}` : '';
  return $switchCaseDefault(schemaVersionName, {
    PITCH: () => `https://prezi.com/view/${linkId}/${referralTokenQuery}`,
    INFOGRAM: () => `https://prezi.com/i/view/${linkId}`
  }, () => '');
};